import React, { Fragment } from "react";

const Markup = ({ renderGeopicker, renderField, Button, ...props }) => {
    const { name, geozone } = props;

    return (
        <Fragment>
            {renderField(name)}
            {renderGeopicker({ ...geozone, withoutRadius: true })}
            {!!Button && <Button />}
        </Fragment>
    );
};
export default Markup;
